var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssuers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ohjortmd7a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "nonzero",
    d: "M16 0c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4h12zm0 .667H4C2.207.667.745 2.082.67 3.855L.667 4v12c0 1.793 1.415 3.255 3.188 3.33l.145.003h12c1.793 0 3.255-1.415 3.33-3.188l.003-.145V4c0-1.793-1.415-3.255-3.188-3.33L16 .667z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ohjortmd7a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M.065 11.483v1.09c0 .143.114.26.26.26h12.397c.142 0 .26-.117.26-.26v-1.09c0-.143-.118-.26-.26-.26H.325c-.146 0-.26.117-.26.26zM.26 4.021h12.402c.145 0 .26-.117.26-.26v-.687c0-.102-.058-.195-.148-.237L6.74.026c-.068-.034-.146-.034-.216-.003L.154 2.835C.06 2.876 0 2.97 0 3.074v.688c0 .142.117.26.26.26zM1.337 9.806c-.145 0-.26.117-.26.26v.638h2.926v-.639c0-.142-.116-.26-.26-.26h-.15V5.437h.15c.144 0 .26-.114.26-.26v-.635H1.077v.636c0 .145.115.26.26.26h.148v4.369h-.148zM9.18 9.806c-.145 0-.26.117-.26.26v.638h2.924v-.639c0-.142-.114-.26-.26-.26h-.148V5.437h.148c.146 0 .26-.114.26-.26v-.635H8.921v.636c0 .145.114.26.26.26h.147v4.369H9.18zM5.257 9.806c-.142 0-.26.117-.26.26v.638h2.927v-.639c0-.142-.117-.26-.26-.26h-.148V5.437h.148c.143 0 .26-.114.26-.26v-.635H4.998v.636c0 .145.117.26.26.26h.147v4.369h-.148z",
    transform: "translate(3.333 3.333)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuers);
export default __webpack_public_path__ + "static/media/issuers.8645285709686d4005be4c1024a4aac1.svg";
export { ForwardRef as ReactComponent };